import React from 'react'
import {SvgPainter} from '../painter/svg-painter'
import type {LvsColorKey} from '../lvs-colors'
import type {ArrowGeometry} from './geometry'
import {paintArrow} from './paint'

export interface ArrowProps {
    readonly geometry: ArrowGeometry
    readonly fill: LvsColorKey
    readonly idSuffix?: string
}

/**
 * Pure SVG renderer driven by the shared painter. Origin is the
 * geometry's local frame (stem-tail center on the central axis).
 * Caller owns the outer <svg> and any positioning.
 */
export function Arrow({geometry, fill, idSuffix = 'arrow'}: ArrowProps): React.ReactElement {
    const p = new SvgPainter('screen', idSuffix)
    paintArrow(p, geometry, fill)
    return <>{p.children()}</>
}
